import type { CSSProperties } from 'react';

/**
 * Inserts a drawing made by the theme's drawing functions.
 *
 * <p>The markup is the theme's own output (see `svg.ts`: text is escaped,
 * numbers are sanitised, colours are validated), never operator or shopper
 * HTML, which is what makes `dangerouslySetInnerHTML` acceptable here.
 */
export function SvgArt({ svg, className, style }: { svg: string; className?: string; style?: CSSProperties }) {
  return <span className={className ? `sk-art ${className}` : 'sk-art'} style={style} dangerouslySetInnerHTML={{ __html: svg }} />;
}
